// extracted by mini-css-extract-plugin
module.exports = {"requiredAsterisk":"RequiredAsterisk_requiredAsterisk__DnjmY"};